// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tw4d","content":"styles_content__16Mbi","tableWrap":"styles_tableWrap__1nJla"};